<template>
    <section class="section-dark">
        <div class="container">
            <h2 class="section-title" v-if="title" v-html="title"></h2>
            <div class="section-content">
                <slot></slot>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'SectionWrapperDark',
    props: {
        title: String,
        darkBg: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped>
.section-dark {
    background: transparent;
    padding: 80px 0;
    color: #fff;
}

.section-dark.alt-bg {
    background: #21252e;
}

.section-title {
    font-size: 48px;
    font-weight: 700;
    color: #fff;
    margin: 0 0 60px 0;
    text-align: center;
}

.section-title :deep(.subtitle) {
    font-size: 16px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.5);
    margin-left: 12px;
    display: inline-block;
}

.section-content {
    color: rgba(255, 255, 255, 0.8);
}

/* Responsive */
@media (max-width: 768px) {
    .section-dark {
        padding: 60px 0;
    }

    .section-title {
        font-size: 36px;
        margin-bottom: 40px;
    }
}
</style>
